import { webStorage } from '@wf/modux'

import { STORAGE_KEY } from '../../../../common/constants/storage-keys'

const COOKIES_CONSENT_LIFETIME = 31536000000 // 60000 ms * 60 mins * 24h * 365d

const DEFAULT_SETTINGS = {
    setupDone: false,
    targetedAd: false,
    analytics: false
}

const getCookiesConsent = () => {
    const storedConsent = webStorage.readDeserialized(STORAGE_KEY.COOKIES_CONSENT)

    if (!storedConsent) {
        return DEFAULT_SETTINGS
    }

    const now = new Date()

    if (now.getTime() > storedConsent.expiry) {
        webStorage.remove(STORAGE_KEY.COOKIES_CONSENT)
        return DEFAULT_SETTINGS
    }

    return storedConsent
}

const setCookiesConsent = settings => {
    const now = new Date()

    webStorage.saveSerialized(STORAGE_KEY.COOKIES_CONSENT, {
        ...settings,
        setupDone: true,
        expiry: now.getTime() + COOKIES_CONSENT_LIFETIME
    })
}

const isAnalyticsEnabled = () => {
    const cookiesConsent = getCookiesConsent()

    return cookiesConsent.analytics
}

export { getCookiesConsent, setCookiesConsent, isAnalyticsEnabled }
